import { Injectable, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService implements OnDestroy {
  private history: string[] = [];
  private unsubscribe = new Subject<void>();

  constructor(private router: Router, private location: Location) {}

  initLocationHistory() {
    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.history) {
          this.history = [];
        }
        if (this.history.slice(-1)[0] !== event.urlAfterRedirects) {
          this.history.push(event.urlAfterRedirects);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  back(): void {
    if (this.history) {
      this.history.pop();
      this.history.length > 0 ? this.location.back() : this.router.navigateByUrl('/');
    } else {
      this.router.navigateByUrl('/');
    }
  }
}
